export const ru = {
    'page-not-found': 'Запрашиваемый ресурс не найден',
    'error': 'Произошла ошибка',
    'no-access': 'У вас нет доступа',
    'internal-server-error': 'Сервер не отвечает',
}
